import React from "react";
import NationalEmblem from "../../../assets/national-emblem.svg";
import Cobranding from "../../../assets/co_branding.svg";

// Desktop-only white government header strip for the auth pages: emblem +
// ministry/department text on the left, Digital India + SAMAVESH co-branding on
// the right. Hidden on md- — mobile keeps each page's existing compact bar.
const AuthTopBar: React.FC = () => (
  <div className="hidden md:flex shrink-0 w-full items-center justify-between border-b border-gray-300 bg-white px-6 py-2">
    <div className="flex items-center gap-4">
      <img
        src={NationalEmblem}
        width={32}
        height={52}
        alt="national-emblem"
        className="h-14 w-auto"
      />
      <div className="flex flex-col leading-tight">
        <span className="mb-0.5 w-fit rounded bg-[#FFD323] px-2 py-0.5 text-[9px] font-bold text-black">
          BETA
        </span>
        <span className="text-[11px] text-[#374151]">Government of India</span>
        <span className="text-[11px] text-[#374151]">
          Ministry of Social Justice &amp; Empowerment
        </span>
        <span className="text-sm font-bold text-[#374151] md:text-base">
          Department of Social Justice &amp; Empowerment
        </span>
      </div>
    </div>
    {/* Left half links to Digital India, right half to SAMAVESH - an
        approximate 50/50 split since the two logos are baked into one image
        with no separate source files or other split marker to go by. */}
    <div className="relative">
      <img
        src={Cobranding}
        width={321}
        height={40}
        alt="Digital India and SAMAVESH"
        className="h-10 w-auto object-contain md:h-12"
      />
      <a
        href="https://www.digitalindia.gov.in/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Digital India"
        title="Digital India"
        className="absolute inset-y-0 left-0 w-1/2 transition hover:opacity-80"
      />
      <a
        href="https://www.dosje.gov.in/"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="SAMAVESH"
        title="SAMAVESH"
        className="absolute inset-y-0 right-0 w-1/2 transition hover:opacity-80"
      />
    </div>
  </div>
);

export default AuthTopBar;
